enum RejectReasonEnum {
    InsufficientDocumentation = 'DOCUMENTATION',
    Other = 'OTHER',
    PoorReputation = 'REPUTATION',
}

export default RejectReasonEnum;
